import { render, staticRenderFns } from "./EventWrapper.vue?vue&type=template&id=83776740&scoped=true&"
import script from "./EventWrapper.vue?vue&type=script&lang=js&"
export * from "./EventWrapper.vue?vue&type=script&lang=js&"
import style0 from "./EventWrapper.vue?vue&type=style&index=0&id=83776740&prod&lang=css&"
import style1 from "./EventWrapper.vue?vue&type=style&index=1&id=83776740&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83776740",
  null
  
)

export default component.exports